"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.durationDisplayFormats = void 0;
exports.durationDisplayFormats = ["compact", "standard", "long"];
